import { Contact, ContactLabels, ContactType } from "../model/Contact";
import API from "./base";
const create = (contact: Contact): Promise<Contact> => {
  return new Promise((resolve, reject) => {
    API.post("/contact-info/create", contact).then(
      (result) => resolve(result.data.payload as Contact),
      reject,
    );
  });
};

const updateById = (
  contact_id: string,
  new_contact: Contact,
): Promise<Contact> => {
  return new Promise((resolve, reject) => {
    API.post("/contact-info/update/" + contact_id, new_contact).then(
      (result) => resolve(result.data.payload as Contact),
      reject,
    );
  });
};

const findById = (id: string): Promise<Contact> => {
  return new Promise((resolve, reject) => {
    API.get("/contact-info/" + id).then((result) => {
      resolve(result.data.payload as Contact);
    }, reject);
  });
};

const deleteById = (id: string): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    API.delete("/contact-info/" + id).then(() => resolve(true), reject);
  });
};

const getAllOrgContacts = (org_id: string): Promise<Array<Contact>> => {
  return new Promise((resolve, reject) => {
    API.get(`/contact-info/organization/${org_id}/all`).then(
      (result) => resolve(result.data.payload as Array<Contact>),
      reject,
    );
  });
};

const findOneByDetailsGlobal = (
  org_id: string,
  label: ContactLabels,
  type: ContactType,
  user_id?: string,
): Promise<Contact> => {
  if (user_id) {
    return new Promise((resolve, reject) => {
      API.get(
        `/contact-info/organization/${org_id}/user/${user_id}/type/${type}/label/${label}`,
      ).then((result) => resolve(result.data.payload as Contact), reject);
    });
  }
  return new Promise((resolve, reject) => {
    API.get(
      `/contact-info/organization/${org_id}/type/${type}/label/${label}`,
    ).then((result) => resolve(result.data.payload as Contact), reject);
  });
};

const getGlobalOrgContacts = (org_id: string): Promise<Array<Contact>> => {
  return new Promise((resolve, reject) => {
    API.get(`/contact-info/organization/${org_id}`).then(
      (result) => resolve(result.data.payload as Array<Contact>),
      reject,
    );
  });
};
const getOrgUserContacts = (
  org_id: string,
  user_id: string,
): Promise<Array<Contact>> => {
  return new Promise((resolve, reject) => {
    API.get(`/contact-info/organization/${org_id}/user/${user_id}`).then(
      (result) => resolve(result.data.payload as Array<Contact>),
      reject,
    );
  });
};

export default {
  create,
  findById,
  deleteById,
  getAllOrgContacts,
  getGlobalOrgContacts,
  getOrgUserContacts,
  updateById,
  findOneByDetailsGlobal,
};
